import Blazy from 'bLazy';

const config = {
  selector: '.js-lazy',
  offset: 600,
};

function init() {
  new Blazy(config); // eslint-disable-line
}

export default {
  init,
}



// WEBPACK FOOTER //
// ./scripts/comps/blazy.js